// extracted by mini-css-extract-plugin
export default {"desc":"TalentPartner_desc__IEv31","cards":"TalentPartner_cards__ryXya"};